export default "__VITE_ASSET__8W9GcOh1__"